'use strict';

var processInclude = require('@sfra/util');

$(document).ready(function () {
    processInclude(require('./giftCard/giftCard'));
});
